export const ASSET_CLASSES = {
	equity: 'Equity',
	fixedIncome: 'Fixed Income',
	allocation: 'Multi Asset',
	alternative: 'Alternatives',
	other: 'Other'
};
